'use client';
import React from 'react';
import { formatRupiah } from '@/lib/mockData';

interface CurrencyDisplayProps {
  value: number;
  className?: string;
  prefixClassName?: string;
  amountClassName?: string;
}

/**
 * Renders a currency value with "Rp" left-aligned and the number right-aligned.
 * Usage: <CurrencyDisplay value={1000000} />
 */
export default function CurrencyDisplay({ value, className = '', prefixClassName = '', amountClassName = '' }: CurrencyDisplayProps) {
  const formatted = formatRupiah(value);
  // Split "Rp 1.000.000" or "Rp\u00A01.000.000" → prefix="Rp" amount="1.000.000"
  const spaceIdx = formatted.search(/[\s\u00A0]/);
  const prefix = spaceIdx !== -1 ? formatted.slice(0, spaceIdx) : 'Rp';
  const amount = spaceIdx !== -1 ? formatted.slice(spaceIdx + 1) : formatted.replace(/^Rp\s*/, '');

  return (
    <span className={`inline-flex min-w-0 max-w-full justify-between gap-1 tabular-nums ${className}`}>
      <span className={`shrink-0 ${prefixClassName}`}>{prefix}</span>
      <span className={`text-right min-w-0 ${amountClassName}`}>{amount}</span>
    </span>
  );
}
